import { readyToSubmit } from '@debbie/common/dist/court/auto-submit.js';
import helpers from '@debbie/common/dist/economy/helpers/index.js';
import { balanceAfterPlan } from '@debbie/common/dist/economy/helpers/payment-plans/index.js';
export const heavyCalcHandlers = {
    generatePaymentPlan: (...args) => {
        const [tenant, creditor, economyEngine, caseVouchers, documents, fixedDistributions, config, conditions, options,] = args;
        return helpers.paymentPlans.gen(tenant, creditor, economyEngine, 
        // The interest pipeline mutates vouchers during calculation. The
        // fallback path runs on the main thread, so clone cached entities here.
        structuredClone(caseVouchers), documents, fixedDistributions, config, conditions, options);
    },
    interestCalculate: (...args) => helpers.interest.calculate(...args),
    balanceAfterPlan: (...args) => balanceAfterPlan(...args),
    getShareVouchers: (...args) => helpers.distributor.getShareVouchers(...args),
    readyToSubmit: (...args) => readyToSubmit(...args),
};
//# sourceMappingURL=handlers.js.map